import { directoryApiClient } from './auth'

export const getFeatureSwitch = async (name: string): Promise<boolean> => {
  const { data } = await directoryApiClient.get<{ enabled: boolean }>(`/api/feature_switches/${name}`)
  return data.enabled
}
